import React from 'react';
import { IndexRedirect, IndexRoute, Route } from 'react-router';
import Application from 'containers/Credit24/LoanApplication/Application';
import HomepageContainer from 'containers/Credit24/LoanApplication/HomepageIncreaseAUContainer';
import LoanFormContainer from 'containers/Credit24/LoanApplication/LoanFormContainer';
import AddressDetails from 'containers/Credit24/LoanApplication/AddressDetailsAUContainer';
import IdentDocuments from 'containers/Credit24/LoanApplication/IdentDocumentsAUContainer';
import FamilyDetails from 'containers/Credit24/LoanApplication/FamilyDetailsAUContainer';
import EducationWorkDetails from 'containers/Credit24/LoanApplication/EducationWorkDetailsAUContainer';
import Income from 'containers/Credit24/LoanApplication/IncomeAUContainer';
import Expenses from 'containers/Credit24/LoanApplication/ExpensesAUContainer';
import Loans from 'containers/Credit24/LoanApplication/LoansAUContainer';
import ScoringStatus from 'containers/Credit24/LoanApplication/ScoringStatusAUContainer';
import OfferDetails from 'containers/Credit24/LoanApplication/OfferDetailsAUContainer';
import LoanPurpose from 'containers/Credit24/LoanApplication/LoanPurposeAUContainer';
import Submit from 'containers/Credit24/LoanApplication/SubmitAUContainer';
import ThankYouPageContainer from 'containers/Credit24/LoanApplication/ThankYouPageContainer';
import FollowUpContainer from 'containers/Credit24/LoanApplication/FollowUpContainer';
import { privateRoute, routeApplicationPart, routeOfferPart } from 'router/routeWrappers';
import { BankScrapingAUContainer } from '../../../containers/Credit24/LoanApplication/BankScrapingAUContainer';

export default () => (
  <Route path="/" name="app" component={Application}>
    <IndexRedirect to="home" />
    <Route path="home" component={HomepageContainer} />
    <Route path="loan" component={privateRoute(LoanFormContainer)}>
      <Route path="bank-details" component={routeApplicationPart(BankScrapingAUContainer, 'CREDIT_SENSE', true)} />
      <Route path="address" component={routeApplicationPart(AddressDetails, 'ADDRESS_AU', true)} />
      <Route path="identification" component={routeApplicationPart(IdentDocuments, 'IDENT_DOCUMENTS', true)} />
      <Route path="family" component={routeApplicationPart(FamilyDetails, 'FAMILY_AU', true)} />
      <Route
        path="education-work"
        component={routeApplicationPart(EducationWorkDetails, 'EDUCATION_WORK', true)}
      />
      <Route path="income" component={routeApplicationPart(Income, 'INCOME_AU', true)} />
      <Route path="expenses" component={routeApplicationPart(Expenses, 'EXPENSES_AU', true)} />
      <Route path="loans" component={routeApplicationPart(Loans, 'LOANS_AU', true)} />
      <Route path="status" component={routeApplicationPart(ScoringStatus, 'SCORING_STATUS_AU', true)} />
      <Route path="offer">
        <IndexRoute component={routeOfferPart(OfferDetails, 'PRODUCT', true, true)} />
        <Route path="loan-purpose" component={routeOfferPart(LoanPurpose, 'LOAN_PURPOSE', true, true)} />
        <Route path="submit" component={routeOfferPart(Submit, 'SUBMIT', true, true)} />
      </Route>
    </Route>
    <Route path="follow-up-questions" component={privateRoute(FollowUpContainer)} />
    <Route path="success" component={privateRoute(ThankYouPageContainer, true)} />
    <Route path="*" component={HomepageContainer} />
  </Route>
);
